/* eslint-disable no-console -- sink console desta fase */
import { getActiveObservabilityContext } from '../runtime';
import type { ISpan, ITracingProvider } from '../tracing/types';
import type {
  ISpanStatus,
  IStartSpanOptions,
  TSpanAttributes,
  TSpanAttributeValue,
} from '../types';

class ConsoleSpan implements ISpan {
  private readonly startedAt = performance.now();
  private ended = false;
  private status: ISpanStatus = { code: 'unset' };
  private readonly attributes: TSpanAttributes;

  constructor(
    private readonly name: string,
    options?: IStartSpanOptions,
  ) {
    this.attributes = { ...(options?.attributes ?? {}) };
    const ctx = getActiveObservabilityContext();
    if (ctx) {
      console.debug('[tracing:start]', this.name, this.attributes, { ctx });
      return;
    }
    console.debug('[tracing:start]', this.name, this.attributes);
  }

  setAttribute(key: string, value: TSpanAttributeValue): void {
    this.attributes[key] = value;
  }

  setAttributes(attributes: TSpanAttributes): void {
    Object.assign(this.attributes, attributes);
  }

  setStatus(status: ISpanStatus): void {
    this.status = status;
  }

  recordException(error: unknown): void {
    this.status = {
      code: 'error',
      message: error instanceof Error ? error.message : String(error),
    };
    const ctx = getActiveObservabilityContext();
    if (ctx) {
      console.error('[tracing:exception]', this.name, error, { ctx });
      return;
    }
    console.error('[tracing:exception]', this.name, error);
  }

  end(): void {
    if (this.ended) return;
    this.ended = true;
    const durationMs = performance.now() - this.startedAt;
    const payload = {
      durationMs: Number(durationMs.toFixed(1)),
      status: this.status,
      attributes: this.attributes,
    };
    const ctx = getActiveObservabilityContext();
    if (ctx) {
      console.debug('[tracing:end]', this.name, payload, { ctx });
      return;
    }
    console.debug('[tracing:end]', this.name, payload);
  }
}

export class ConsoleTracingProvider implements ITracingProvider {
  startSpan(name: string, options?: IStartSpanOptions): ISpan {
    return new ConsoleSpan(name, options);
  }

  async flush(): Promise<void> {}

  async shutdown(): Promise<void> {}
}